import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/UserHierarchy.css';

function UserHierarchy() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [hierarchies, setHierarchies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [usersResponse, hierarchiesResponse] = await Promise.all([
        api.getUsers(),
        api.getAllUserHierarchies()
      ]);
      
      setUsers(usersResponse.data || []);
      setHierarchies(hierarchiesResponse.data || []);
      setError('');
    } catch (err) {
      setError('Failed to load data: ' + err.message);
      console.error('Error loading data:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (parentUserId, childUserId) => {
    if (!window.confirm('Are you sure you want to remove this hierarchy relationship?')) {
      return;
    }

    try {
      await api.removeUserChild(parentUserId, childUserId);
      setError('');
      alert('Hierarchy removed successfully!');
      loadData();
    } catch (err) {
      setError('Failed to remove hierarchy: ' + err.message);
    }
  };

  const getUserName = (userId) => {
    const user = users.find(u => u.id === userId);
    return user ? user.email : `User #${userId}`;
  };

  if (loading) {
    return <div className="user-hierarchy-container"><div className="loading">Loading...</div></div>;
  }

  return (
    <div className="user-hierarchy-container">
      <div className="hierarchy-header">
        <h1>User Hierarchy Management</h1>
        <button className="btn btn-primary" onClick={() => navigate('/user-hierarchy/new')}>
          Assign Hierarchy
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="hierarchy-stats">
        <div className="stat-card">
          <h3>Total Users</h3>
          <p className="stat-value">{users.length}</p>
        </div>
        <div className="stat-card">
          <h3>Hierarchy Relationships</h3>
          <p className="stat-value">{hierarchies.length}</p>
        </div>
      </div>

      <div className="hierarchy-list">
        <h2>Current Hierarchies</h2>
        
        {hierarchies.length === 0 ? (
          <div className="no-hierarchies">
            <p>No hierarchy relationships found</p>
            <button className="btn btn-primary" onClick={() => navigate('/user-hierarchy/new')}>
              Create First Hierarchy
            </button>
          </div>
        ) : (
          <div className="hierarchy-table">
            <table>
              <thead>
                <tr>
                  <th>Parent User (Manager)</th>
                  <th>Child User (Subordinate)</th>
                  <th>Assigned Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {hierarchies.map((hierarchy, index) => (
                  <tr key={index}>
                    <td className="user-email">
                      {getUserName(hierarchy.parent_user_id)}
                    </td>
                    <td className="user-email">
                      {getUserName(hierarchy.child_user_id)}
                    </td>
                    <td>
                      {hierarchy.created_at 
                        ? new Date(hierarchy.created_at).toLocaleDateString()
                        : '-'}
                    </td>
                    <td>
                      <button
                        onClick={() => handleRemove(hierarchy.parent_user_id, hierarchy.child_user_id)}
                        className="btn btn-sm btn-danger"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserHierarchy;
